import { Component, Input } from '@angular/core';
import { PopupFieldData } from 'src/app/features/designer-studio/edit-pdf-doc/models/doc.model';

@Component({
  selector: 'app-screen-combobox',
  templateUrl: './combobox.component.html',
  styleUrls: ['./combobox.component.scss']
})
export class ComboboxComponent {
  @Input() initOptions: PopupFieldData;
}
